// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as IconNext$Showside from "../icons/IconNext.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as StylableElement$Showside from "./StylableElement.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
function SectionTitle(Props) {
  var minimalOpt = Props.minimal;
  var showArrowOpt = Props.showArrow;
  var text = Props.text;
  var onClick = Props.onClick;
  var minimal = minimalOpt !== undefined ? minimalOpt : true;
  var showArrow = showArrowOpt !== undefined ? showArrowOpt : false;
  var match = ViewportContext$Showside.use(undefined);
  var isMobile = match.isMobile;
  var titleTextSize = match.breakpoint >= 2 ? "text-3xl" : Cn.make([minimal ? "text-xl" : "text-2xl"]);
  var renderArrow = function (param) {
    return React.createElement(ConditionalRender$Showside.When.make, {
      condition: showArrow,
      children: React.createElement("div", {
        className: CSS$Showside.prefix("translate-x-1 group-2-hover:translate-x-2 transform-gpu transition duration-300")
      }, React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make(["transform-gpu transition duration-300 group-hover:duration-150 text-accent", isMobile ? "" : "opacity-0 -translate-x-0 group-hover:opacity-100 group-hover:translate-x-1/2"]))
      }, React.createElement(IconNext$Showside.make, {
        className: CSS$Showside.prefix("w-4 h-4"),
        strokeWidth: "5"
      })))
    });
  };
  var tmp = {
    "aria-level": 2,
    className: CSS$Showside.prefix("inline-flex items-center gap-1 flex-grow-0"),
    role: "button"
  };
  var tmp$1 = Belt_Option.map(onClick, function (param) {
    return 0;
  });
  if (tmp$1 !== undefined) {
    tmp.tabIndex = Caml_option.valFromOption(tmp$1);
  }
  if (onClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick);
  }
  return React.createElement(DataAttribute$Showside.make, {
    dataTestId: "clp-sectionheader-title",
    children: React.createElement("div", tmp, React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make([minimal ? "line-clamp-1" : "line-clamp-2", "font-semibold text-primary no-underline", "font-heading", titleTextSize]))
    }, React.createElement(StylableElement$Showside.make, {
      className: "section__title",
      children: text
    })), renderArrow(undefined))
  });
}
SectionTitle.displayName = "SectionTitle";
var make = SectionTitle;
export { make };
/* react Not a pure module */